import React from 'react';
import { setColorsPanelAction } from '../../containers/Configurator/actions/general';
import { switchModeAction } from '../../containers/ModeBar/actions';
import { ConfiguratorMode } from '../../containers/ModeBar/reducer';
import { FiX } from 'react-icons/all';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
// import styled from 'styled-components';

const PaintInstructions = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <div className="absolute w-full flex justify-center bottom-0 -mb-48  text-gray-800 ">
      <div className="flex flex-col">
        <div className="bg-white  px-4 py-2 border border-gray-400">
          <ul>
            <li className="flex items-center py-2">
              <div className="flex justify-center items-center bg-main text-white py-0 px-2 rounded-full text-lg">
                1
              </div>
              <div className="ml-2 text-lg">
                {t('Please select a colour first')}
              </div>
            </li>
            <li className="flex items-center py-2">
              <div className="flex justify-center items-center bg-main text-white py-0 px-2 rounded-full text-lg">
                2
              </div>
              <div className="ml-2 text-lg">
                {t('Then click on the piece of furniture to be colored')}
              </div>
            </li>
          </ul>
        </div>
        <div className="mt-5 bg-white border border-gray-400 text-xl py-2 px-3">
          <button
            onClick={() => {
              dispatch(setColorsPanelAction());
              dispatch(switchModeAction(ConfiguratorMode.selector));
            }}
            className="flex items-center w-full"
          >
            <FiX className="h-6 w-6 mr-2" /> {t('Exit paint mode')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaintInstructions;
